import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import Square from './components/Square';
import Axinan from './components/Axinan';
import Bubble from './components/Bubble';
import Porthole from './components/Porthole';

import Loading from './components/Loading';

class App extends Component {
  state = {
    axinan: false,
    square: false,
    bubble: false,
    porthole: false,
  }
  handleOnClick = (name) => {
    this.setState({[name]: true});
  }
  render() {
    return (
      <div className="App">
        <h1><span className="large-font">R</span>eact <span className="large-font">L</span>oading <span className="large-font">C</span>ollection</h1>
        <button onClick={this.handleOnClick.bind(this, 'axinan')}>Axinan</button>
        <button onClick={this.handleOnClick.bind(this, 'square')}>Square</button>
        <button onClick={this.handleOnClick.bind(this, 'bubble')}>Bubble</button>
        <button onClick={this.handleOnClick.bind(this, 'porthole')}>Porthole</button>
        <Loading onClick={() => this.setState({axinan: false})} show={this.state.axinan} style={{background: "rgba(0, 0, 0, 0.6)"}}>
          <Loading.Component component={Axinan}>
          </Loading.Component>
          <Loading.Label style={{'letterSpacing': '8px', 'paddingLeft': '8px'}} label="AXINAN" />
        </Loading>
        <Loading onClick={() => this.setState({square: false})} show={this.state.square} style={{fontFamily: 'Bungee'}}>
          <Loading.Component component={Square}>
            <Loading.Icon icon="fa-download" />
          </Loading.Component>
          <Loading.Label style={{'letterSpacing': '4px', 'paddingLeft': '8px'}} label="Square" />
        </Loading>
        <Loading onClick={() => this.setState({bubble: false})} show={this.state.bubble}>
          <Loading.Component component={Bubble}>
            <Loading.Icon icon="fa-comments" />
          </Loading.Component>
          <Loading.Label style={{'letterSpacing': '8px', 'paddingLeft': '8px'}} label="Bubble" />
        </Loading>
        <Loading onClick={() => this.setState({porthole: false})} show={this.state.porthole}>
          <Loading.Component component={Porthole}>
            <Loading.Icon icon="fa-arrow-up" />
          </Loading.Component>
        </Loading>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js